module.exports = __webpack_public_path__ + "img/banner-vip.919d9da4.jpg";